import { render } from "./SelectTip.vue?vue&type=template&id=baab4dfa&scoped=true"
import script from "./SelectTip.vue?vue&type=script&lang=js"
export * from "./SelectTip.vue?vue&type=script&lang=js"

import "./SelectTip.vue?vue&type=style&index=0&id=baab4dfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baab4dfa"]])

export default __exports__